export const SET_START_TIME = "SET_START_TIME";
export const SET_END_TIME = "SET_END_TIME";
export const SET_PEOPLE_COUNT = "SET_PEOPLE_COUNT";
export const SET_SELECTED_DATE = "SET_SELECTED_DATE";
export const REMOVE_END_TIME = "REMOVE_END_TIME";
export const SET_START_TIME_UTC = "SET_START_TIME_UTC";
export const SET_SELECTED_DURATION = "SET_SELECTED_DURATION";
export const CLEAR_USER_VALUES = "CLEAR_USER_VALUES";
